import { Component, Input, OnInit } from '@angular/core';
import icHome from '@iconify/icons-ic/twotone-home';
import { TranslateService } from '@ngx-translate/core';
import { trackByValue } from '../../utils/track-by';

@Component({
  selector: 'vex-breadcrumbs',
  template: `
    <div class="flex items-center">
      <vex-breadcrumb>
        <a [routerLink]="['/home']">
          <ic-icon [icon]="icHome" inline="true" size="20px"></ic-icon>
          <span style="display:none">Home</span>
        </a>
      </vex-breadcrumb>
      <ng-container *ngFor="let crumb of crumbs; trackBy: trackByValue">
        <div class="w-1 h-1 bg-gray rounded-full ltr:mr-2 rtl:ml-2"></div>
        <vex-breadcrumb>
          <a *ngIf="isRoute(crumb)" [routerLink]="[crumb.route]">{{ crumb.name | translate }}</a>
          <a *ngIf="!isRoute(crumb)" [routerLink]="[]">{{ crumb | translate }}</a>
        </vex-breadcrumb>
      </ng-container>
    </div>
  `
})
export class BreadcrumbsComponent implements OnInit {

  @Input() crumbs: string[] = [];

  trackByValue = trackByValue;
  icHome = icHome;

  constructor(public translate: TranslateService) {
  }

  ngOnInit() {

  }

  isRoute(crumb) {
    if (typeof(crumb) === 'undefined') {
      return false;

    } else if (typeof(crumb.route) === 'undefined') {
      return false;
    }

    return true;
  }
}
